import { IOrganizationState } from "@/core/interfaces/organizationState.interface";

const state: IOrganizationState = {
  organizations: [],
  isFetchingOrganizations: false,
  organization: null,
  isAddingAgent: false,
  isDeletingAgentFromOrganization: false,
  isFetchingOrganization: false,
  isCreatingOrganization: false,
  isUpdatingOrganization: false,
  isUpdateWebsiteConfigurationLoading: false,
  isUpdateWebsiteContentLoading: false,
  isWebsiteConfigLoading: false,
  websiteConfig: null,
  websiteContent: null,
  passengerActionLoading: false,
  passengers: [],
  isFetchingPassengers: false,
  travelerProfiles: [],
  travelerProfilesPaginationMeta: null,
  travelerProfilesSearchQuery: "",
  isFetchingTravelerProfiles: false,
  organizationUsers: [],
  isSearchingOrganizationUsers: false,
  isFetchingPassengerSetupForm: false,
  organizationPassengerSetupForm: null,
  organizationPassengerSetupFormV2: null,
  referenceOptions: {},
  organizationEmployeeGrades: null,
  organizationCostCenters: null,
  organizationDepartments: null,
  isFetchingOrganizationEmployeeGrades: false,
  isFetchingOrganizationCostCenters: false,
  isFetchingOrganizationDepartments: false,
  fetchingReferenceUrls: new Set<string>(),
  isWhatsappMembersLoading: false,
  whatsappActionLoading: false,
  whatsappMembers: [],
  whatsappMembersCount: 0,
  whatsappMembersNext: null,
  whatsappMembersPrevious: null,
  whatsappMembersCurrentPage: 1,
  whatsappMembersPageSize: 10,
  isGenerateOTPLoading: false,
  isOrganizationStatsLoading: false,
  operations_users: [],
  organizationStats: null,
  organizationProductivity: null,
  isCurrenciesLoading: false,
  currencies: [],
  isOrganizationProductivityLoading: false,
  sectors: null,
  pia_provider: null,
  curreny: null,
  isDocumentUploadLoading: false,
  saasEliteOrganization: [],
  isEliteOrganizationStatusUpdating: false,
  errorOrganizationNotFound: false,
  internalProvidersLoading: false,
  pia_providers: null,
  airblue_providers: null,
  isUpdateFinancialProfileProvidersLoading: false,
  isFetchPricinglistLoading: false,
  isFetchPricingFormLoading: false,
  pricingList: [],
  pricingFormDetails: null,
  selectedOrganizationId: null,
  isPricingFormSubmissionPending: false,
  activePassenger: null,
  isFetchingActivePassenger: false,
  isUpdatingPassenger: false,
  isValidatingBulkUsers: false,
  isImportingBulkUsers: false,
  bulkUserValidateResult: null,
  bulkUserImportResult: null,
};

export default state;
